import { ApiService } from "app/services/api-service.interface";

export class AutoCompleteConfig implements AutoCompleteConfigProps {
    
    service: ApiService<any>;
    keyword: string;
    useValue: string;
    useLabel: string;
    labelFunction?: (value: any) => string;
    additionalCriteria?: { [key: string]: any };  

    constructor (config?: AutoCompleteConfigProps) {
        this.service = config.service;
        this.keyword = config.keyword;
        this.useValue = config.useValue;
        this.useLabel = config.useLabel;
        this.labelFunction = config.labelFunction;
        Object.assign(this, config);
    };
}

interface AutoCompleteConfigProps {
    service: ApiService<any>,
    keyword: string
    useValue: string;
    useLabel: string;
    labelFunction?: (value: any) => string;
    additionalCriteria?: { [key: string]: any };  
}